import { render, staticRenderFns } from "./OpsCollectionManagement.vue?vue&type=template&id=6134cd07&"
import script from "./OpsCollectionManagement.vue?vue&type=script&lang=js&"
export * from "./OpsCollectionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports